import './CurrentWorkspaceSelectLinkInTable.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_WorkspaceOwnerIcon } from '../../../../../design/icons/S_WorkspaceOwnerIcon/S_WorkspaceOwnerIcon';
import { S_Link } from '../../../../../design/links/S_Link';

interface IProps {
  workspaceId: string;
  name: string;
  isEncrypted: boolean;
  isLocked: boolean;
  isMy: boolean;
  onClick: (workspaceId: string) => void;
}

export const CurrentWorkspaceSelectLinkInTable = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const handleClick = (): void => {
    props.onClick(props.workspaceId);
  };
  const prefix = props.isEncrypted ? '🔒 ' : '';
  const suffix = props.isLocked ? '(locked)' : '';
  return (
    <span className='current-workspace-select-link'>
      <S_WorkspaceOwnerIcon
        isMine={props.isMy}
        notOwnerTitle={t('workspaces.list.you_are_invited_tooltip')}
      />
      <S_Link
        color='text'
        disabled={props.isLocked}
        title={props.name}
        onClick={handleClick}
      >
        {`${prefix}${props.name}${suffix}`}
      </S_Link>
    </span>
  );
});
